// Home.tsx
import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../dashboard/Dashboard";
import Drive from "../drive/Drive/Drive";
import Reports from "../reports/Reports";
import Profile from "../profile/Profile";
import TaskPage from "../taskPage/TaskPage";
import NewFileRequirementForm from "../taskPage/taskAttachments/NewFileRequirementForm";
import RecurringTaskCreation from "../task/taskCreation/RecurringTaskCreation";
import TaskCreationSelector from "../task/taskCreation/TaskCreationSelector";
import EditRecurringTasksPage from "../task/taskEdit/EditRecurringTasksPage";
import EditWorkflows from "../workflow/EditWorkflows";
import EditParticipantPage from "../participants/EditParticipantPage";
import FileViewPage from "../fileViewer/FileViewPage";
import CreateParticipantPage from "../participants/CreateParticipantPage";
import TeamMemberDashboard from "../dashboard/TeamMemberDashboard";
import CreateTaskActivityComponent from "../taskActivity/CreateTaskActivityComponent";
import EditTemplateInterimTasks from "../task/taskEdit/EditTemplateInterimTasks";
import AddTemplateInterimTask from "../task/taskEdit/AddTemplateInterimTask";
import TaskCreationPage from "../task/taskCreation/TaskCreationPage";
import EditTemplateFiles from "../templateFiles/EditTemplateFiles";
import AddTemplateFile from "../templateFiles/AddTemplateFile";
import CreateNewTaskActivityType from "../taskActivity/CreateNewTaskActivityType";
import CreateNewTaskActivityPage from "../taskActivity/CreateNewTaskActivityPage";
import TasksPageComponent from "../TasksPage/TasksPageComponent";
import BumpParticipantForm from "../participants/BumpParticipantForm";
import UserFileViewPage from "../fileViewer/UserFileViewPage";
import GeneratedSuggestionComponent from "../generatedSuggestions/GeneratedSuggestionComponent";
import SuggestionRulesComponent from "../generatedSuggestions/SuggestionRulesComponent";
import ParticipantPage from "../participants/ParticipantPage";
import TagList from "../task/tagCreation/TagList";
import TagCreationForm from "../task/tagCreation/TagCreationForm";
import DriveParticipant from "../drive/Drive/caseFileDrive/DriveParticipant";
import DriveYear from "../drive/Drive/caseFileDrive/DriveYear";
import CaseFileDrive from "../drive/Drive/caseFileDrive/CaseFileDrive";
import { DriveProvider } from "../../../contexts/DriveContext";
import PersonalDrive from "../drive/Drive/personalDrive/PersonalDrive";
import UserProfile from "../userComponents/UserProfile";
import ChatPage from "../realtimeChatComponents/ChatPage";
import PageNotFound from "../errorPages/PageNotFound";
import Unathorized from "../errorPages/Unauthorized";
import PDFEditor from "../fileViewer/pdfViewer/PDFEditor";
// import SpreadsheetEditor from "../fileViewer/excel/SpreadsheetEditor";
import SproutSheets from "../fileViewer/sproutSheets/SproutSheets";
import OwnerDashboard from "../dashboard/OwnerDashboard/OwnerDashboard";
import { FormPage } from "../formFillComponents/FormPage";
import FormBuilder from "../formFillComponents/formBuilder/FormBuilder";
import MappingBuilder from "../formFillComponents/mappingBuilder/MappingBuilder";
import FormAdminPanel from "../formFillComponents/adminPanel/FormAdminPanel";
import Navbar from "../../navigation/Navbar/Navbar";
import MyCalendar from "../calendar/MyCalendar";
import SignDocument from "../signature/SignDocument";
import CaseFileViewPage from "../fileViewer/CaseFileViewPage";
import ViewFile from "../ViewFiles/ViewFile";
import Notificationtab from "../notificationtab/Notificationtab";
import EmployeeFiles from "../profile/EmployeeFiles";
import Participantfiles from "../participantfiles/Participantfiles";
import WeeklySupervisionList from "../weeklySupervision/WeeklySupervisionList";
import WeeklySupervisionForSupervisor from "../weeklySupervision/WeeklySupervisionForSupervisor";
import Forbidden from "../forbidden/Forbidden";
import Commingsoon from "../commingsoon/Commingsoon";
import ManagerRequest from "../userComponents/userProfileComponents/ManageRequest";
import Privacypolicy from "../privacypolicy/Privacypolicy";
import Termsservices from "../termsservices/Termsservices";
import Resourcerequest from "../resourcerequest/Resourcerequest";
import Serviceoverviewtab from "../serviceoverviewtab/Serviceoverviewtab";
import Infotab from "../infotab/Infotab";
import Caseloadindependence from "../caseloadindependence/Caseloadindependence";
import Employeesurveys from "../employeesurveys/Employeesurveys";
import Surveys from "../surveys/Surveys";
import Prestormsurvey from "../prestormsurvey/Prestormsurvey";
import Relocationsurvey from "../relocationsurvey/Relocationsurvey";
import Poststormsurvey from "../poststormsurvey/Poststormsurvey";
import Activitiestab from "../activitiestab/Activitiestab";
import Taskstab from "../taskstab/Taskstab";
import Documentstab from "../documentstab/Documentstab";
import Filestab from "../filestab/Filestab";
import EmployeeReportTab from "../userComponents/ReportTab/EmployeeReportTab";
import Cir from "../cir/Cir";
import Audittab from "../audittab/Audittab";
import RecentFilesPage from "../serviceoverviewtab/RecentFilePageTab/RecentFilesPage";
import Settings from "../settings/Settings";
import SharedFilesDrive from "../drive/Drive/sharedFilesDrive/SharedFilesDrive";
import ParticipantActivityPage from "../ParticipantActivityPage/ParticipantActivityPage";
import ReportsPage from "../Samples/ReportsPage";
import TermsOfService from "../../legal/eSign/TermsOfService";
import Insights from "../insights/Insights";
import IssuesPageComponent from "../IssuesPage/IssuesPageComponent";
import IssuePage from "../issuePage/IssuePage";
import ExternalFileRequests from "../ExternalFileReqeust/ExternalFileRequests";
import SprintsListPage from "../sprintview/SprintsListPage";
import SprintDetailPage from "../sprintview/SprintDetailPage";
import AgingReport from "../agingReport/AgingReport";
import WikiHomepage from "../wiki/WikiHomepage";
import WikiEditorWrapper from "../wiki/WikiEditorWrapper";
import UnderConstruction from "../errorPages/UnderConstruction";
import ParticipantSnapshotTab from "../participant-snapshot/ParticipantSnapshotTab";
import EventCountdown from "../../ui/EventTimer/EventTimer";

import DriveRoutes from "./DriveRoutes";
import OwnerParticipantsElement from "../dashboard/OwnerDashboard/OwnerParticipantsElement";
import ExternalFileRequestHeader from "../ExternalFileReqeust/ExternalFileRequestHeader";
import EmployeeFileViewPage from "../fileViewer/EmployeeFileViewPage";
import { AdminTemplateDashboard } from "../adminDashboards/adminRecurringTaskJobStatsDashboard/AdminTemplateDashboard";

const Home: React.FC = () => {
  const [darkMode, setDarkMode] = useState(() => {
    // Check for saved dark mode preference and initialize state accordingly
    const savedMode = localStorage.getItem("darkMode");
    return savedMode === "true"; // returns true if savedMode is 'true', otherwise false
  });

  useEffect(() => {
    // Check for saved dark mode preference
    const isDarkMode = localStorage.getItem("darkMode") === "true";
    setDarkMode(false);
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };
  const now = new Date(); // Get the current date and time

  now.setHours(now.getHours() + 24);
  return (
    <>
      {/* <div className="fixed bottom-5 right-5 z-50"> */}
      {/* <GeneratedSuggestionComponent /> */}
      {/* </div> */}
      <Navbar toggleDarkMode={toggleDarkMode} isDarkMode={darkMode}>
        <Routes>
          <Route path="/home" element={<Dashboard />}></Route>
          <Route path="/dashboard" element={<Dashboard />}></Route>
          <Route path="/dashboard/owner/*" element={<OwnerDashboard />}></Route>
          <Route path="/dashboard/*" element={<TeamMemberDashboard />}></Route>
          <Route path="/sheets" element={<SproutSheets />}></Route>
          <Route
            path="/event-timer"
            element={
              <EventCountdown
                targetDate={now}
                title="Quarterly Board Meeting"
                description="Review of Q3 financial results and projection for the upcoming fiscal year."
                meetingUrl="https://zoom.us/j/123456789"
              />
            }
          ></Route>
          <Route path="unauthorized" element={<Unathorized />} />
          <Route
            path="weekly-supervision"
            element={<WeeklySupervisionList />}
          />
          <Route
            path="weekly-supervision-supervisor"
            element={<WeeklySupervisionForSupervisor />}
          />
          <Route
            path="/edit/suggestionRules/*"
            element={<SuggestionRulesComponent />}
          ></Route>
          <Route path="/drive/*" element={<DriveRoutes />} />
          {/* <Route
                        path="/edit/participant/:id/*"
                        element={<ParticipantPage />}
                    >
                        <Route index element={<Navigate to="service-overview" replace />} />
                        <Route path="service-overview" element={<Serviceoverviewtab />} />
                        <Route path="info" element={<Infotab />} />
                    </Route> */}
          <Route path="/edit/participant/:id/*" element={<ParticipantPage />}>
            <Route index element={<Navigate to="service-overview" replace />} />
            <Route path="service-overview" element={<Serviceoverviewtab />} />
            {/* <Route path="participant-snapshot" element={<ParticipantSnapshotTab />} /> */}
            <Route path="info" element={<Infotab />} />
          </Route>
          <Route
            path="/participant/:id/participant-snapshot"
            element={<ParticipantSnapshotTab />}
          />
          <Route
            path="/edit/task/recurring/*"
            element={<EditRecurringTasksPage />}
          ></Route>
          <Route path="/reportsPage" element={<ReportsPage />}></Route>
          <Route path="/edit/workflows/*" element={<EditWorkflows />}></Route>
          <Route
            path="/edit/participants/new"
            element={<CreateParticipantPage />}
          ></Route>
          <Route
            path="/participants"
            element={<OwnerParticipantsElement />}
          ></Route>
          <Route
            path="/edit/participants/*"
            element={<EditParticipantPage />}
          ></Route>
          <Route
            path="/edit/interims/*"
            element={<EditTemplateInterimTasks />}
          ></Route>
          0{" "}
          <Route
            path="/edit/templateFiles/*"
            element={<EditTemplateFiles />}
          ></Route>
          <Route
            path="/addtask/new/interim/template/*"
            element={<AddTemplateInterimTask />}
          ></Route>
          <Route path="/reports/*" element={<Reports />}></Route>
          <Route path="/profile/user/:userId" element={<UserProfile />}>
            <Route index element={<Navigate to="activities" replace />} />
            <Route path="activities" element={<Activitiestab />} />
            <Route path="tasks" element={<Taskstab />} />
            <Route path="documents" element={<Documentstab />} />
            <Route path="files" element={<Filestab />} />
            <Route path="reports" element={<EmployeeReportTab />} />
          </Route>
          <Route path="/chat/:conversationId?" element={<ChatPage isSideView={false} showHeader={true} />}></Route>
          <Route path="/profile/*" element={<Profile />}></Route>
          {/* <Route
                        path="/addtask/new/recurring"
                        element={<RecurringTaskCreation />}
                    ></Route> */}
          <Route
            path="/file/new/template"
            element={<AddTemplateFile />}
          ></Route>
          <Route
            path="/addActivity/new/activity/template"
            element={<CreateNewTaskActivityType />}
          ></Route>
          <Route
            path="/task/edit/activity/template"
            element={<CreateNewTaskActivityPage />}
          ></Route>
          <Route
            path="/addActivity/new/activity/*"
            element={<CreateTaskActivityComponent />}
          ></Route>
          {/* <Route
                        path="/addtask/new/interim"
                        element={<TaskCreationPage />}
                    ></Route> */}
          <Route path="/addtask/new/*" element={<TaskCreationSelector />}>
            <Route index element={<Navigate to="interim" replace />} />
            <Route path="recurring" element={<RecurringTaskCreation />} />
            <Route path="interim" element={<TaskCreationPage />} />
          </Route>
          <Route
            path="/task/:taskId/addRequiredFile"
            element={<NewFileRequirementForm />}
          ></Route>
          <Route path="/task/:taskId" element={<TaskPage />}></Route>
          <Route path="/task/*" element={<TaskPage />}></Route>
          <Route path="/edit/file/:fileId" element={<PDFEditor />}></Route>
          <Route path="/view/file/:fileId" element={<FileViewPage />}></Route>
          <Route
            path="/view/user/file/:fileId"
            element={<UserFileViewPage />}
          ></Route>
          <Route
            path="/view/employee/file/:fileId"
            element={<EmployeeFileViewPage />}
          ></Route>
          <Route
            path="/view/file/:fileId/:fileTable"
            element={<ViewFile />}
          ></Route>
          <Route
            path="/casefile/file/:fileId"
            element={<CaseFileViewPage />}
          ></Route>
          <Route path="/form/fill" element={<FormPage />}></Route>
          <Route
            path="/form/create/:editFormId?"
            element={<FormBuilder />}
          ></Route>
          <Route
            path="/form/mapping/:editFormId?"
            element={<MappingBuilder />}
          ></Route>
          <Route path="/form/admin" element={<FormAdminPanel />}></Route>
          <Route path="/form" element={<FormPage />}></Route>
          <Route
            path="/edit/participants/bump/:participantId"
            element={<BumpParticipantForm />}
          ></Route>
          <Route path="/tags" element={<TagList />} />
          <Route
            path="/tags/new"
            element={<TagCreationForm isEdit={false} />}
          />
          <Route
            path="/tags/edit/:id"
            element={<TagCreationForm isEdit={true} />}
          />
          <Route path="/calendar" element={<MyCalendar />} />
          {/* <Route path="/tasks/*" element={<TasksPage />} /> */}
          <Route path="/tasks/*" element={<TasksPageComponent />} />
          <Route path="/issues/*" element={<IssuesPageComponent />} />
          <Route path="/issue/:issueId" element={<IssuePage />} />
          <Route path="/sprints" element={<SprintsListPage />} />
          <Route path="/sprints/:sprintId" element={<SprintDetailPage />} />
          <Route path="/signDocument" element={<SignDocument />} />
          <Route path="/notification" element={<Notificationtab />} />
          <Route path="/employeeFiles" element={<EmployeeFiles />} />
          <Route path="/forbidden" element={<Forbidden />} />
          {/* <Route path="/wiki" element={<WikiHomepage />} /> */}
          <Route path="/wiki" element={<UnderConstruction />} />
          <Route
            path="/wiki/spaces/:spaceId/:pageId?"
            element={<WikiEditorWrapper />}
          />
          <Route path="/commingsoon" element={<Commingsoon />} />
          <Route path="/admin-requests" element={<ManagerRequest />} />
          <Route path="/privacypolicy" element={<Privacypolicy />} />
          <Route path="/admin/dashboard" element={<AdminTemplateDashboard />} />
          <Route path="/termsservices" element={<TermsOfService />} />
          <Route path="/resourcerequest" element={<Resourcerequest />} />
          <Route
            path="/caseloadindependence"
            element={<Caseloadindependence />}
          />
          <Route
            path="/employeesurveys/:instanceId"
            element={<Employeesurveys />}
          />
          <Route
            path="/surveys/participant/:participantId?"
            element={<Surveys />}
          />
          <Route
            path="/prestormsurvey/:participantId/:instanceId"
            element={<Prestormsurvey />}
          />
          <Route
            path="/relocationsurvey/:participantId/:instanceId"
            element={<Relocationsurvey />}
          />
          <Route
            path="/poststormsurvey/:participantId/:instanceId"
            element={<Poststormsurvey />}
          />
          <Route path="/cir" element={<Cir />} />
          <Route path="/audittab" element={<Audittab />} />
          <Route
            path="/participant/:participantId/service-overview/recentfiles"
            element={<RecentFilesPage />}
          />
          <Route
            path="/participant/:id/activity"
            element={<ParticipantActivityPage />}
          />
          <Route path="/settings" element={<Settings />} />
          <Route path="/insights" element={<Insights />} />
          <Route
            path="/external-file-request"
            element={<ExternalFileRequestHeader />}
          />
          <Route path="/aging-report" element={<AgingReport />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Navbar>
      {/* For Owner */}
      <Routes>
        {/* <Route path="/dashboard/owner/*" element={<OwnerDashboard />} /> */}
      </Routes>
    </>
  );
};

export default Home;
